import { useState, useEffect, useRef } from "react";
import { Search, X } from "lucide-react";

/**
 * Reusable debounced, clearable search input for module list screens.
 * - value/onChange are the DEBOUNCED term (parent drives the query with it).
 * - Mirrors the existing bookings-search pattern (300ms debounce).
 */
export function SearchInput({ value, onChange, placeholder = "Search…", testid = "module-search", className = "", debounce = 300, autoFocus = false }) {
  const [q, setQ] = useState(value || "");
  const first = useRef(true);
  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    const t = setTimeout(() => onChange(q.trim()), debounce);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
      <input
        value={q}
        autoFocus={autoFocus}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        className="w-full rounded-lg border border-slate-200 bg-white pl-9 pr-8 py-2 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
      />
      {q && (
        <button onClick={() => { setQ(""); onChange(""); }} data-testid={`${testid}-clear`}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" aria-label="Clear search">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
